<template>
   <button 
     type="button" 
     class="relative p-2 text-cream-100 hover:text-gold-400 transition-colors duration-200"
   >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      class="h-6 w-6" 
      fill="none" 
      viewBox="0 0 24 24" 
      stroke="currentColor"
    >
      <path 
        stroke-linecap="round" 
        stroke-linejoin="round" 
        stroke-width="2" 
        d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" 
      />
    </svg>
    
    <span 
      v-if="count > 0"
      class="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-bold leading-none text-white bg-burgundy-800 rounded-full border border-noir-900"
    >
      {{ count > 99 ? '99+' : count }}
    </span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  count: number;
}>();
</script>
